import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7190db4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "itembox" }
const _hoisted_3 = { class: "topBox" }
const _hoisted_4 = { class: "center" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "score" }
const _hoisted_10 = { class: "num" }
const _hoisted_11 = { class: "btnBox" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.ckwdhd'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: $setup.loading,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.loading) = $event)),
      onRefresh: $setup.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: $setup.loading,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (($setup.loading) = $event)),
          finished: $setup.finished,
          "finished-text": $setup.t('me.mygdl'),
          onLoad: $setup.onLoad
        }, {
          default: _withCtx(() => [
            ($setup.listData.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.listData, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_van_image, {
                        radius: "10",
                        "lazy-load": "",
                        fit: "cover",
                        width: "80",
                        height: "80",
                        src: item.gift_info.cover
                      }, null, 8 /* PROPS */, ["src"]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, _toDisplayString(item.gift_info.name), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_7, _toDisplayString($setup.t('me.integralex')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.score), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_10, "x" + _toDisplayString(item.num), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: "kfbtn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toServer()))
                      }, _toDisplayString(_ctx.$t('me.lxkf')), 1 /* TEXT */),
                      (item.is_add_info == 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "dzbtn",
                            onClick: ($event: any) => ($setup.addAddress(item))
                          }, _toDisplayString($setup.t('me.addaddress')), 9 /* TEXT, PROPS */, _hoisted_12))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading", "finished", "finished-text"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}